import styled from 'styled-components';
import { colourPalette, hexToRGBA } from 'styles/styles';
import { PDropdown } from 'components/prime/PDropdown/PDropdown';

export const ColumnTypeStyle = {
  Container: styled.div`
    position: relative;
  `,
  CustomSelector: styled(PDropdown)`
    min-height: 36px !important;
    min-width: 160px !important;
    & .p-dropdown-label {
      padding: 1px 12px 0 40px !important;
    }
    & .p-dropdown-trigger {
      padding: 2px 0 0 0;
    }
    &:focus,
    &.p-inputwrapper-focus,
    &:focus-within {
      box-shadow: 0px 0px 0px 4px ${hexToRGBA(colourPalette.blue600, 0.3)} !important;
      border: 1px solid ${colourPalette.blue600} !important;
    }
    &.p-disabled {
      opacity: 1;
      background: ${colourPalette.neutral50} !important;
      .p-dropdown-label {
        color: ${colourPalette.neutral400} !important;
      }
      .p-dropdown-trigger {
        color: ${colourPalette.neutral400};
      }
    }
  `,
  IconContainer: styled.div<{ disabled?: boolean }>`
    position: absolute;
    top: 0;
    height: 36px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ disabled }) =>
      disabled &&
      `
      svg {
        & > path {
          fill: ${colourPalette.neutral400};
        }
      }
    `}
  `,
};
